import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';

const Services = () => {
  const [services, setServices] = useState([
    {
      id: 1,
      title: 'Strategic Consultation',
      description: 'Enterprise architecture assessment, technology roadmapping, and digital transformation strategy aligned with business objectives.',
      icon: 'fas fa-lightbulb',
      gradient: 'from-blue-50 to-cyan-50',
      border: 'border-blue-100',
      iconBg: 'bg-primary/10 group-hover:bg-primary/20',
      iconColor: 'text-primary',
      features: [
        'Technology Audit & Assessment',
        'Digital Transformation Roadmap',
        'Architecture Design & Planning'
      ]
    },
    {
      id: 2,
      title: 'Agile Development',
      description: 'Full-stack development leveraging modern frameworks, microservices architecture, and cloud-native technologies for scalable solutions.',
      icon: 'fas fa-code',
      gradient: 'from-purple-50 to-pink-50',
      border: 'border-purple-100',
      iconBg: 'bg-purple-600/10 group-hover:bg-purple-600/20',
      iconColor: 'text-purple-600',
      features: [
        'Custom Software Development',
        'API Design & Integration',
        'Microservices Architecture'
      ]
    },
    {
      id: 3,
      title: 'Cloud Deployment',
      description: 'Automated deployment pipelines, containerization, and infrastructure-as-code for reliable, scalable, and secure cloud environments.',
      icon: 'fas fa-rocket',
      gradient: 'from-green-50 to-teal-50',
      border: 'border-green-100',
      iconBg: 'bg-accent/10 group-hover:bg-accent/20',
      iconColor: 'text-accent',
      features: [
        'CI/CD Pipeline Setup',
        'Container Orchestration',
        'Infrastructure as Code'
      ]
    },
    {
      id: 4,
      title: 'Proactive Maintenance',
      description: '24/7 monitoring, performance optimization, security patching, and incident response to ensure maximum uptime and system reliability.',
      icon: 'fas fa-tools',
      gradient: 'from-orange-50 to-red-50',
      border: 'border-orange-100',
      iconBg: 'bg-orange-600/10 group-hover:bg-orange-600/20',
      iconColor: 'text-orange-600',
      features: [
        '24/7 System Monitoring',
        'Performance Optimization',
        'Security & Compliance'
      ]
    }
  ]);

  useEffect(() => {
    // Fetch services from API when available
    const fetchServices = async () => {
      try {
        const response = await apiService.getServices();
        if (response.data && response.data.length > 0) {
          setServices(response.data);
        }
      } catch (error) {
        console.log('Using default services data');
      }
    };

    fetchServices();
  }, []);

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Core Service Portfolio
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive IT services engineered to optimize your technology stack and 
            accelerate business outcomes through strategic digital initiatives.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className={`group bg-gradient-to-br ${service.gradient} rounded-xl p-8 hover:shadow-xl transition-all duration-300 border ${service.border}`}
            >
              <div className={`${service.iconBg} w-16 h-16 rounded-lg flex items-center justify-center mb-6 transition-colors`}>
                <i className={`${service.icon} text-2xl ${service.iconColor}`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">
                {service.description}
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                {service.features.map((feature, index) => (
                  <li key={index} className="flex items-center">
                    <i className="fas fa-check text-accent mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
